import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  FormsModule,
  ReactiveFormsModule
} from '@angular/forms';
import { NgxSpinnerModule } from 'ngx-spinner';
import {
  DxPopupModule,
  DxBoxModule,
  DxButtonModule,
} from 'devextreme-angular';
import { OptionMonitorComponent } from './components/option-monitor/option-monitor.component';
import { OptionMonitorFiltersComponent } from './components/filters/option-monitor-filters.component';
import { OptionMonitorTableComponent } from './components/option-monitor-table/option-monitor-table.component';
import { ChartsWindowComponent } from './components/dialogs/charts-window/charts-window.component';
import { SharedModule } from '../shared/shared.module';
import { ChartsModule } from '../charts/charts.module';
import { CalculatorsModule } from '../calculators/calculators.module';
import { CreditModule } from '../credit/credit.module';
import { ContractViewerDialogComponent } from './components/dialogs/contract-viewer-dialog/contract-viewer-dialog.component';
import {
  TuiGroupModule,
  TuiGroupStylesComponent,
  TuiHintModule,
  TuiLoaderModule
} from '@taiga-ui/core';
import { TuiRadioBlockModule } from '@taiga-ui/kit';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    NgxSpinnerModule,
    DxPopupModule,
    DxBoxModule,
    DxButtonModule,
    ChartsModule,
    CalculatorsModule,
    CreditModule,
    ReactiveFormsModule,
    TuiGroupModule,
    TuiRadioBlockModule,
    TuiLoaderModule,
    TuiHintModule
  ],
  declarations: [
    OptionMonitorComponent,
    OptionMonitorFiltersComponent,
    OptionMonitorTableComponent,
    ChartsWindowComponent,
    ContractViewerDialogComponent
  ],
  entryComponents: [
    ContractViewerDialogComponent,
    TuiGroupStylesComponent
  ],
  exports: [
    OptionMonitorComponent
  ]
})
export class OptionMonitorModule {
}
